"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconArmCurl = void 0;

var React = __importStar(require("react"));

exports.IconArmCurl = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return React.createElement("svg", _objectSpread(_objectSpread({
    width: "41",
    height: "40",
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef
  }), React.createElement("path", {
    d: "M7.16901e-07 32.1126C7.16901e-07 41.8793 11.6927 40.7232 15.8772 38.3673C21.0104 39.3946 35.6372 38.7521 40.1673 32.1126C41.1161 30.7422 41.2459 29.0289 40.5987 27.486C39.0887 24.0158 35.5932 16.6069 31.4946 12.6229C25.9718 7.26857 22.6942 2.98512 21.9591 1.95623C21.226 0.928886 20.2333 -0.314344 17.8166 0.0721953C15.3999 0.457038 11.3891 1.8291 11.9483 2.98529C12.4657 4.185 14.1914 5.51184 13.8459 5.72601C13.2426 6.06902 12.292 5.89668 12.292 6.8822C12.292 7.90955 13.4566 8.68091 15.6997 8.68091C17.5552 8.68091 19.2809 9.36695 21.9995 9.58112C24.0707 9.75179 26.0542 14.8502 27.0908 18.6616C27.7818 21.2317 28.4289 23.9307 28.8165 25.4299C28.9025 25.8582 28.4289 26.2013 28.0834 25.9436C26.6173 24.958 23.6392 23.33 20.7931 23.5877C17.9888 23.8018 16.8664 24.615 16.1772 25.1722C15.4862 25.7294 14.7969 26.6279 14.3655 27.6134C14.2796 27.8276 14.0638 27.9564 13.8043 27.9564C13.7184 27.9564 13.6745 27.9129 13.5886 27.9129C13.2869 27.7841 13.1572 27.4411 13.2869 27.1851C13.6324 26.4137 14.0638 25.7712 14.5374 25.2575C9.23205 21.7036 0.000250876 22.8598 0.000250876 32.1128L7.16901e-07 32.1126Z",
    fill: color
  }));
});